module.exports = __webpack_public_path__ + "img/top_banner1.7e6b7212.png";